import FormattedMessage from 'I18n/components/FormattedMessage';
import { Body, EmptyState, LayoutVertical } from 'breeze-intelligence-kit';
import { ILLUSTRATION_SIZE } from '../../constants';
import { BasePanel } from '../Panel/BasePanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function SmartPropertiesPanelEmpty({
  children,
  propertiesCount
}) {
  if (propertiesCount === 0) {
    return /*#__PURE__*/_jsx(BasePanel.Body, {
      children: /*#__PURE__*/_jsxs(EmptyState, {
        layout: "vertical",
        paddingBlock: "space-3xl",
        children: [/*#__PURE__*/_jsx(EmptyState.Illustration, {
          inlineSize: ILLUSTRATION_SIZE,
          name: "calculated-properties"
        }), /*#__PURE__*/_jsx(EmptyState.SecondaryContent, {
          children: /*#__PURE__*/_jsxs(LayoutVertical, {
            alignItems: "center",
            justifyContent: "center",
            maxInlineSize: "52ch",
            textAlign: "center",
            children: [/*#__PURE__*/_jsx(EmptyState.Title, {
              as: "h5",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "enrichmentSettings.smartPropertiesPage.empty.title"
              })
            }), /*#__PURE__*/_jsx(Body, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "enrichmentSettings.smartPropertiesPage.empty.description"
              })
            })]
          })
        })]
      })
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
}